import { BaseModel } from "../../core/src/model/BaseModel";
import { IVendorData } from "./IVendorData";
import { IFreeGamesVendorData } from "./IFreeGamesVendorData";


class VendorModel extends BaseModel<IVendorData> {
    public playId = "";

    /**
     * Keeps the last play state at the backend.
     * openPlay (1) -> placeBet (2) -> getBetResult (3) -> settlePlay (4) -> closePlay (5)
     *
     * @type {number}
     * @memberof GameModel
     */
    public lastPlayState: number = 0;

    public freeGames: IFreeGamesVendorData = null;
    // Change this for specific games if u want to spin swipe
    public allowSwipeSpin: boolean = false;

    public htmlHistoryBufferSizeForSpins: number;

    public isNebuTomb = false;
    public isHauntedHause = false;

}

export default new VendorModel();

